export const outlineOnlySymbol = {
    type: "simple-fill",  // autocasts as new SimpleFillSymbol()
    color: [51, 51, 204, 0.9],
    style: "none",
    outline: {  // autocasts as new SimpleLineSymbol()
        color: "green",
        width: 7
    }
};